import ADIColors from "@NA/Utils/ADIColors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { BillToModel } from "@insite/client-framework/Types/ApiModels";
import BillingAddressInfoDisplay, {
    BillingAddressInfoDisplayStyles,
} from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/BillingAddressInfoDisplay";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getColor from "@insite/mobius/utilities/getColor";
import React from "react";
import { css } from "styled-components";

export interface ADIBillingAddressDisplay {
    billingAddressborder?: InjectableCss;
    billingAddressGridContainer?: GridContainerProps;
    billingAddress?: BillingAddressInfoDisplayStyles;
    billingInfoGridItem?: GridItemProps;
    billingInfoDisplayGridItem?: GridItemProps;
}

export const adiBillingAddressDisplay: ADIBillingAddressDisplay = {
    billingInfoGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            > ${TypographyStyle} {
                color: ${ADIColors.darkBlack3};
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                margin-bottom: 0px;
                                font-size: 14px;
                            `,
                            null,
                            null,
                            null,
                        ],
                        "max",
                    )}
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding-right: 0px;
                            padding-bottom: 0px;
                            padding-top: 0px;
                        `,
                        null,
                        css`                           
                            padding-bottom: 0px;                            
                        `,
                        null,
                    ],
                    "max",
                )}
              @media (min-width: 768px) and (max-width: 1079px) {
               .titleDisplay {
                  margin-bottom: 0px;
                }
            }
                
        `,
    },
    billingInfoDisplayGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            address {
                text-transform: capitalize;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding-top: 0px;
                            padding-right: 0px;
                        `,
                        null,
                        css`
                            padding-top: 0px;
                        `,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    billingAddressborder: {
        css: css`
            border-top: 1px solid ${getColor("common.border")};
            width: calc(100% + 48px);
            display: inline-block;
            margin-top: 35px;
            margin-bottom: 25px;
            margin-left: -23px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding: 0px;
                            margin-left: -15px;
                            width: calc(100% + 30px);
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    billingAddressGridContainer: {
        css: css`
            padding-bottom: 25px;
            > ${GridOffset} {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                flex-direction: column;
                            `,
                            null,
                            css`
                            flex-direction: column;
                        `,
                            null,
                        ],
                        "max",
                    )}
            }
        `,
    },
    billingAddress: {
        container: {
            css: css`
                ${TypographyStyle} {
                    font-size: ${getProp("theme.typography.headerSecondary.size")};
                }
            `,
        },
        headingGridItem: {
            css: css`
                display: none;
            `,
        },
    },
};

const styles = adiBillingAddressDisplay;

const ADIBillingAddressDisplay = ({ billToState }: { billToState: BillToModel }) => {
    return (
        <>
            {billToState && (
                <>
                    <StyledWrapper {...styles.billingAddressborder}></StyledWrapper>
                    <GridContainer {...styles.billingAddressGridContainer}>
                        <GridItem {...styles.billingInfoGridItem}>
                            <Typography className = "titleDisplay" variant="h6">{translate("Billing Information:")}</Typography>
                        </GridItem>
                        <GridItem {...styles.billingInfoDisplayGridItem}>
                            <BillingAddressInfoDisplay
                                billTo={billToState}
                                onEdit={() => {}}
                                extendedStyles={styles.billingAddress}
                            />
                        </GridItem>
                    </GridContainer>
                </>
            )}
        </>
    );
};

export default ADIBillingAddressDisplay;
